export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ01.8fb61530.mp3";